import { getCookie } from '@/utils/auth';
import { isUploadResultNewVersionEnabled } from '@/utils/uploadResultAB';

const getMenus = () => {
  const dataAnalysisAB = getCookie('data_analysis_ab');
  const uploadResultNewVersionEnabled = isUploadResultNewVersionEnabled();
  return [
    {
      title: '首页',
      icon: 'home',
      key: '/home'
    },
    {
      title: '进出管理',
      key: '/visitor',
      icon: 'visitor'
    },
    {
      title: '订单管理',
      icon: 'order',
      key: '/order',
      subs: [
        {key: '/order/orders', title: '所有订单', icon: '',},
        {key: '/order/assigned', title: '已分派订单', icon: ''},
        {key: '/order/transport', title: '运输中订单', icon: ''},
        {key: '/order/scanQRcode', title: '待扫码订单', icon: ''},
        {key: '/order/experiment', title: '待上传结果订单', icon: ''},
        ...(
          uploadResultNewVersionEnabled
            ? [{key: '/order/upload-result', title: '结果数据上传', icon: ''}]
            : []
        ),
        {key: '/order/review', title: '待审核结果订单', icon: ''},
        {key: '/order/finish', title: '已完成订单', icon: ''},
        {key: '/order/retest', title: '复测订单', icon: ''},
        // {key: '/order/settle', title: '待结算订单', icon: ''},
        {key: '/order/recovery', title: '样品回收订单', icon: ''},
        {key: '/order/sample', title: '样品回收订单', icon: ''},
        {key: '/order/negative', title: '争议/差评订单', icon: ''},
        {key: '/order/overtime', title: '超期/即将超期订单', icon: ''},
        {key: '/order/feedback', title: '意见反馈订单', icon: ''},
        {key: '/order/forward-order', title: '转寄订单', icon: ''},
      ]
    },
    {
      title: '结算管理',
      icon: 'order',
      key: '/settlement-management',
    },
    {
      title: '实验成本登记',
      icon: 'costRegistration',
      key: '/experiment-cost-registration',
    },
    {
      title: '寄样订单预排班',
      icon: 'project',
      key: '/sendSampleOrder'
    },
    {
      title: '仪器管理',
      icon: 'project',
      key: '/instrumentManagement',
      subs: [
        {key: '/instrumentManagement/instrumentList', title: '仪器列表', icon: '',},
        {key: '/instrumentManagement/maintenanceRecord', title: '仪器维保记录', icon: '',},
        {key: '/instrumentManagement/scheduleList', title: '仪器排班表', icon: ''},
        {key: '/instrumentManagement/machineTimeManagement', title: '机时管理', icon: ''},
      ]
    },
    {
      title: '测试项目',
      icon: 'project',
      key: '/testProject'
    },
    {
      title: '绩效管理',
      icon: 'project',
      key: '/performance',
    },
    {
      title: '测试案例库',
      icon: 'caseLibrary',
      key: '/caselibrary',
      subs: [
        {key: '/caselibrary/caselibrarys', title: '案例库', icon: '',},
        // 跟crmv2一致
        {key: '/caselibrary/caselibrary-process', title: '测试方法库', icon: '',},
      ],
    },
    ...(
      dataAnalysisAB === '1'
        ? [{
          title: '分析数据模板',
          icon: 'dataAnalysisProduct',
          key: '/data-analysis-product/product-list'
        }]
        : []
    ),
    {
      title: '账户主页',
      icon: 'user',
      key: '/user',
      subs: [
        {key: '/user/index', title: '个人资料', icon: '',},
        // {key: '/user/settlement', title: '历史结算', icon: '',},
        {key: '/user/teamManagement', title: '团队管理', icon: '',},
        // {key: '/user/account', title: '账号与安全', icon: '',},
      ]
    },
    {
      title: '关于研趣·科学指南针',
      icon: 'platform',
      key: '/platform',
      subs: [
        {key: '/platform/protocol', title: '平台协议规则', icon: '',},
      ]
    }
  ]
}

export default getMenus;
